import { createSlice } from "@reduxjs/toolkit"



const initialState={
    
    currentCollector:'',
    loading:false,
}

const collectorSlice=createSlice({
name:'singleCollector',

initialState,
reducers:{
    
    loginSuccessSC:(state,{payload})=>{
        state.loading=false;
        state.currentCollector=payload;
        

    },
    deleteAllCol:(state)=>{
        state.currentCollector=''
    }
    

}
})
export const {loginSuccessSC,deleteAllCol}=collectorSlice.actions

export default collectorSlice.reducer